export const savjetiList = [
  {
    pitanje: "Koja je razlika između neuromodulatora i filera?",
    odgovor:
      "Neuromodulatori su najbolji izbor kod uklanjanja dinamickih bora i djeluju tako da smanjuju mišićnu aktivnost i tako doprinose pomlađenom izgledu. Mogu se koristiti i kao terapija hiperhidroze. Filere koristimo kad želimo vratiti izgubljeni volumen i zagladiti kožu uslijed dehidracije.",
  },
  {
    pitanje: "Kolika je trajnost filera?",
    odgovor:
      "Trajnost ovisi o mnogim faktorima ali općenito možemo reći da je učinak vidljiv do 9 mjeseci, ponekad i više od godine dana.",
  },
  {
    pitanje:
      "Ako se odlučim više nikad ne koristiti filere i neuromodulatore, hoće li moje lice izgledati gore nego prije?",
    odgovor:
      "To se nikako ne može dogoditi jer stavljena hijaluronska kiselina stanje kože može samo popraviti, a prestankom apliciranja koža je još uvijek u boljem stanju nego prije prve aplikacije. Djelovanje neuromodulatora prestaje za 3-6 mjeseci, a s vremenom mišići se manje kontrahiraju pa mimika lica bude ublažena čak i nakon prestanka korištenja.",
  },
  {
    pitanje: "Mogu li odmah na posao nakon tretmana?",
    odgovor:
      "U svakom tretmanu moguće su modrice, najčešće su male i lako se maskiraju puderom. Otečenost usana moze biti 2-3 dana. Važno je slijediti upute prije i poslije tretmana.",
  },
  {
    pitanje: "Kako djeluje microneedling?",
    odgovor:
      "To je postupak korištenja specijalnog uređaja koji sterilnim ubodima mikroiglicama do 2mm i uz pomoć mezoterapijskih koktela, pomaže stvaranju novog kolagena koji omogućava glađu, čvršću kožu.",
  },
  {
    pitanje:
      "Hoću li izgledati umjetno nakon aplikacije neuromodulatora ili filere?",
    odgovor:
      "Ne brinite, pravilnom i umjerenom primjenom i s pristupom 'manje je više', pobrinut ćemo se da se to ne dogodi. Nakon naših tretmana pacijenti najčešće dobiju kompliment da izgledaju kao da su se dobro naspavali ili vratili s godišnjeg odmora.",
  },
  {
    pitanje: "Jesu li tretmani bolni?",
    odgovor:
      "Nisu jer se koristimo anestetskom kremom a ponekad i dentalnim anestetskim injekcijama.",
  },
  {
    pitanje:
      "Zašto trebam posjećivati stomatologa barem 2 puta godišnje ako nemam problema?",
    odgovor:
      "Redoviti pregledi pomažu da se problem koji pacijent ne primjećuje, dijagnosticira na samom početku, pa se tako i intervencije svedu na minimalno invazivne. Često je početni karijes dugo bez simptoma, ali stomatolog ga može uočiti puno ranije, ponekad i samo uz pomoć rtg snimke. Na redovitim kontrolama moguće je pacijenta i na vrijeme upozoriti na pogreške koje radi u održavanju oralne higijene, pa ga se može na vrijeme educirati i spriječiti novi karijesi i parodontitis.",
  },
  {
    pitanje:
      "Genetski imam lošu kvalitetu zuba, mogu li spriječiti karijes i parodontitis?",
    odgovor:
      "Naravno, moguće je ostvariti da u životu nikad ne dobijete karijes, treba samo redovito i pravilno održavati oralnu higijenu. Četkica, zubni konac i redoviti pregledi Vaši su saveznici. Dođite i naučit ćemo Vas kako!",
  },
  {
    pitanje: "Jako se bojim, mora li popravak zuba boljeti?",
    odgovor:
      "Naravno da ne mora, u današnje vrijeme, kad je anestezija sastavni dio tretmana, a pažljiv pristup svakom pacijentu obaveza, ne morate imati neugodu ni strah.",
  },
  {
    pitanje: "Trebam li prati zube nakon svakog obroka?",
    odgovor:
      "Ne treba, zapravo bi bilo poželjno pričekati barem 30 minuta, pogotovo ako ste jeli ili pili kisele namirnice. Naime slina je ta kojoj treba dopustiti da neutralizirali kiselu sredinu u ustima nastalu nakon hrane ili nakon povraćanja, pogotovo u trudnoći. Nakon toga treba nježno očetkati zube sa četkicom i zubnom pastom, a potom i koncem.",
  },
  {
    pitanje: "Moram li koristiti zubni konac svaku večer?",
    odgovor:
      "Jako je važno svaki dan koristiti zubni konac jer on jedino može dosegnuti kontaktne točke između zuba koje nisu dostupne ni četkici. Pravilno korištenje konca može se naučiti vrlo brzo, ali isto tako nepravilno korištenje, baš kao i nepravilna upotreba četkice može dovesti do abrazije zuba. Svakog pacijenta redovito upućujemo u tajne oralne higijene, na obostrano zadovoljstvo.",
  },
  {
    pitanje: "Kako odabrati najbolji materijal za zubne krunice ili mostove?",
    odgovor:
      "Odabir materijala je dobro prepustiti stručnjaku jer najbolji materijal u danom slučaju ovisi o mnogo čimbenika kao što su: preostala struktura zuba, raspored članova mosta, željena estetika i na koncu financijske mogućnosti pacijenta. Možete biti sigurni da ćemo pomno razmotriti sve elemente i u suradnji s Vama  i zubnim tehničarom izabrati najbolje za Vas.",
  },
]
